export default __webpack_public_path__ + "static/media/2017 (3).8cfd2319.jpg";